import axios from 'axios';

class FreeformController {
    constructor() {
        this.forms = null;
    }

    init() {
        this.forms = $('.section-form form');
        this.forms.on('submit.bws-freeform', this.onSubmit.bind(this));
        $('button[type="submit"]', this.forms).on('click.bws-freeform', this.onSubmit.bind(this));
        $('input[required],select[required],textarea[required]', this.forms).on('blur.bws-freeform', event => {
            this.checkInputValidity(event.currentTarget);
        });
    }

    // on form submit, check for errors and send data via ajax
    async onSubmit(event) {
        event.preventDefault();

        let form = null;
        if ($(event.currentTarget).is('form')) {
            form = $(event.currentTarget);
        } else {
            form = $(event.currentTarget).closest('form');
        }

        $('.success-message', form).addClass('hidden');
        $('.error-message', form).addClass('hidden');

        let isValid = this.checkForm(form);
        
        // if valid, submit form
        if (!isValid) return false;

        $('input[type="submit"], button[type="submit"]', form).attr('disabled', true);

        let method =  form.attr('method') || 'post';
        let url = $('input[name="action"]').val() || '/freeform/api/form';
        let headers = {
            'X-Requested-With': 'XMLHttpRequest',
            HTTP_X_REQUESTED_WITH: 'XMLHttpRequest'
        }
        let data = form.serialize();

        try {
            let response = await axios({
                url: url,
                method: method,
                headers: headers,
                data: data
            });
            $('input[type="submit"], button[type="submit"]', form).attr('disabled', false);

            console.log($('.error-message', form));

            if (response.data.success && response.data.finished) {
                $('.success-message', form).removeClass('hidden');
            } else if (response.data.errors || response.data.formErrors) {
                var errorMessage = "";
                if (response.data.errors) {
                    for (let key in response.data.errors) {
                        if (!response.data.errors.hasOwnProperty(key)) continue;

                        errorMessage += '<p><strong>' + key + ':</strong><ul class="errors">';

                        for (let i=0; i<response.data.errors[key].length; i++) {
                            errorMessage += '<li>' + response.data.errors[key][i] + '</li>';
                        }

                        errorMessage += '</ul></p>';
                    }
                }

                if (response.data.formErrors) {
                    for (let key in response.data.formErrors) {
                        if (!response.data.formErrors.hasOwnProperty(key)) continue;
                        
                        errorMessage += '<div class="error"><strong>' + key + ':</strong><ul class="errors">';

                        for (let i=0; i<response.data.formErrors[key].length; i++) {
                            errorMessage += '<li>' + response.data.formErrors[key][i] + '</li>';
                        }

                        errorMessage += '</ul></div>';
                    }
                }
                console.log(errorMessage);
                console.log($('.error-message .error-information', form));
                $('.error-message .error-information', form).html(errorMessage);
                $('.error-message', form).removeClass('hidden');
            }
        } catch(e) {
            $('input[type="submit"], button[type="submit"]', form).attr('disabled', false);
            console.log("Error", e);
        }
    }

    // checks all form inputs for validity. 
    checkForm(form) {
        let isValid = true;
        form.addClass('is-submitted');

        $('input[required],select[required],textarea[required]', form).each((index, input) => {
            if (!this.checkInputValidity(input)) {
                isValid = false;
            };
        });

        return isValid;
    }

    // checks a form input for validity, and adds error classes and labels when necessary
    checkInputValidity(input) {
        const inputParent = $(input).closest('.field-container').eq(0)[0];
        const inputId = input.id;

        let errorMsg = input.getAttribute('data-msg-error');
        let requireMsg = input.getAttribute('data-msg-required');
        let defaultRequiredMsg = 'This field is required.';
        let defaultErrorMsg = 'This field is invalid.';

        let label_error;

        input.setAttribute('aria-invalid', !input.checkValidity());
        if (!input.checkValidity()) {
            if (!document.querySelector('#' + inputId + '-error')) {
                label_error = document.createElement('p');
                label_error.setAttribute('id', inputId + '-error');
                label_error.setAttribute('class', 'form-error is-visible');
                inputParent.insertBefore(label_error, input.nextSibling);
            } else {
                label_error = document.querySelector('#' + inputId + '-error');
            }

            if (input.value === '') {
                requireMsg ? (requireMsg = requireMsg) : (requireMsg = defaultRequiredMsg);
                label_error.innerHTML = requireMsg;
            } else {
                errorMsg ? (errorMsg = errorMsg) : (errorMsg = defaultErrorMsg);
                label_error.innerHTML = errorMsg;
            }
            inputParent.classList.add('has-invalid-input');
            inputParent.classList.remove('has-valid-input');
            input.classList.add('is-invalid-input');
            input.setAttribute('aria-describedby', inputId + '-error');
            return false;
        } else {
            if (document.querySelector('#' + inputId + '-error')) {
                label_error = document.querySelector('#' + inputId + '-error');
                label_error.parentNode.removeChild(label_error);
            }

            inputParent.classList.remove('has-invalid-input');
            inputParent.classList.add('has-valid-input');
            input.classList.remove('is-invalid-input');
            input.removeAttribute('aria-describedby');
            return true;
        }
    }

    destroy() {
        $('button[type="submit"]', this.forms).off('click.bws-freeform');
        $('input[required], select[required], textarea[required]', this.forms).off('blur.bws-freeform');
        this.forms.off('submit.bws-freeform');
        this.forms = null;
    }
}

export default FreeformController;